import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=15716a7a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=15716a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15716a7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15716a7a')) {
      api.createRecord('15716a7a', component.options)
    } else {
      api.reload('15716a7a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=15716a7a&scoped=true&", function () {
      api.rerender('15716a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oTD4RQ9Q1UWQ/JS/comp/SearchFilterTokens.vue"
export default component.exports